import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@sdk';
import {
    OtpRepository,
    OtpCodeVerificationParams,
    OtpPhoneNumberVerificationParams,
    OtpVerificationErrorApiResponse,
    OtpPhoneNumberVerificationResponse,
} from '@packlink/packlink-sdk';

const optRepository = new OtpRepository(apiClient);

export type OtpVerificationErrorResponse = { response: { data: { messages: OtpVerificationErrorApiResponse[] } } };

export const useOtpVerification = () => {
    const { mutate: sendPhoneNumberMutation } = useMutation<
        OtpPhoneNumberVerificationResponse,
        OtpVerificationErrorResponse,
        OtpPhoneNumberVerificationParams
    >({
        mutationFn: (phoneNumberPayload: OtpPhoneNumberVerificationParams) =>
            optRepository.sendPhoneNumberVerification(phoneNumberPayload),
    });

    const { mutate: verifyOtpCodeMutation } = useMutation<
        void,
        OtpVerificationErrorResponse,
        OtpCodeVerificationParams
    >({
        mutationFn: (otpCodePayload: OtpCodeVerificationParams) => optRepository.verifyOtpCode(otpCodePayload),
    });

    return {
        sendPhoneNumberMutation,
        verifyOtpCodeMutation,
    };
};
